import { Group, Text } from '@mantine/core'
import { Anchor, Breadcrumbs as MantineBreadcrumbs } from '@mantine/core'
import { TbChevronRight } from 'react-icons/tb'
import HomeIcon from '~/icon/home.svg'

export type BreadcrumbItem = {
  id: string
  title: string
  href?: string
}

type BreadcrumbsProps = {
  items: BreadcrumbItem[]
}

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { items } = props

  const defaultHomeItem = { id: 'home', title: 'ホーム', href: '/' }
  const allItems = [defaultHomeItem, ...items].map((item, index) => {
    if (index === 0) {
      return (
        <Anchor key={item.id} href={item.href} fw='bold' size='sm' lh='xs'>
          <Group gap='xs' align='center'>
            <HomeIcon />
            {item.title}
          </Group>
        </Anchor>
      )
    }

    if (item.href) {
      return (
        <Anchor key={item.id} href={item.href} fw='bold' size='sm' lh='xs'>
          {item.title}
        </Anchor>
      )
    }

    return (
      <Text key={item.id} fw='bold' size='sm' lh='xs'>
        {item.title}
      </Text>
    )
  })

  return (
    <MantineBreadcrumbs
      separator={<TbChevronRight size={14} />}
      separatorMargin='xs'
    >
      {allItems}
    </MantineBreadcrumbs>
  )
}
